import { FormattedMessage } from 'react-intl'

import Button, { ButtonProps } from 'app/components/base/Button'
import SetMaxBidDialog from 'app/components/dialogs/SetMaxBidDialog'
import useVerifyAuth from 'app/features/ListingFeature/hooks/useVerifyAuth'
import useModal from 'app/hooks/useModal'

interface SetMaxBidButtonProps extends ButtonProps {
  auctionId: number
  currency: string
  onSuccess?: () => void
  onError?: () => void
  exchangeRate?: number
}

const SetMaxBidButton: RFC<SetMaxBidButtonProps> = ({
  auctionId,
  currency,
  onSuccess,
  onError,
  exchangeRate,
  sx,
  ...restProps
}) => {
  const { open, hideModal, showModal } = useModal()

  const checkAuth = useVerifyAuth()

  return (
    <>
      <Button
        size="large"
        variant="outlined"
        sx={{ flex: 1, ...sx }}
        onClick={() => checkAuth(showModal)}
        {...restProps}
      >
        <FormattedMessage defaultMessage="Set Max Bid" />
      </Button>

      {open && (
        <SetMaxBidDialog
          open={open}
          onClose={hideModal}
          auctionId={auctionId}
          currency={currency}
          exchangeRate={exchangeRate}
          onSuccess={onSuccess}
          onError={onError}
        />
      )}
    </>
  )
}

export default SetMaxBidButton
